/**
 * Utility functions for data validation
 */

/**
 * Validates a Chinese ID card number
 *
 * @param {string} idCard - The ID card number to validate
 * @returns {boolean} - True if the ID card number is valid, false otherwise
 */
export function validateIdCard (idCard) {
  if (!idCard) {
    return false;
  }

  // Standardize the format (uppercase X)
  idCard = idCard.toUpperCase();

  // Basic format validation
  if (!/^[1-9]\d{5}(19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/.test(idCard)) {
    return false;
  }

  // Check birth date validity
  const year = idCard.substring(6, 10);
  const month = idCard.substring(10, 12);
  const day = idCard.substring(12, 14);

  const date = new Date(year, parseInt(month) - 1, day);
  if (date.getFullYear() !== parseInt(year) ||
      date.getMonth() + 1 !== parseInt(month) ||
      date.getDate() !== parseInt(day)) {
    return false;
  }

  // Checksum validation (18-digit ID only)
  if (idCard.length === 18) {
    const factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
    const parity = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'];
    let sum = 0;

    for (let i = 0; i < 17; i++) {
      sum += parseInt(idCard.charAt(i)) * factor[i];
    }

    if (parity[sum % 11] !== idCard.charAt(17)) {
      return false;
    }
  }

  return true;
}

/**
 * Creates validation rules for Chinese ID card field
 *
 * @param {boolean} required - Whether the field is required or not
 * @returns {Array} - Array of validation rules
 */
export function idCardRules (required = true) {
  const rules = [];

  if (required) {
    rules.push(v => !!v || '请输入身份证号');
  }

  rules.push(
    v => !v || /^[1-9]\d{5}(19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}(\d|X|x)$/.test(v) || '身份证号格式不正确'
    // v => !v || validateIdCard(v) || '身份证号校验失败'
  );

  return rules;
}
